// extracted by mini-css-extract-plugin
export var homeEmoji = "HomePage-module--home-emoji--_-L2T";
export var home = "HomePage-module--home--1CP3g";
export var fontanim = "HomePage-module--fontanim--3zYgH";
export var strapLine = "HomePage-module--strap-line--1iXaA";
export var homeInfo = "HomePage-module--home-info--3zOD-";
export var bio = "HomePage-module--bio--35yJ0";